import styled from 'styled-components';

export const Container = styled.div`
    
    svg .country {
        stroke: #282b3a;
        stroke-width: 0.5px;
    }
`;
